import { Module } from 'vuex'
import { RootState } from '@/store/index'
import { mutations } from '@/store/modules/orderItem/mutations'
import { IOrderItemState, initialState } from '@/store/modules/orderItem/state'

export * from '@/store/modules/orderItem/state'

export const store: Module<IOrderItemState, RootState> = {
  state: initialState,
  mutations
}
